<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="expoMeetingDocCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:documentation="{ row }">
        <div class="doc__content-main">
          <div
            class="doc__content-file__suffix"
            :style="{
              'background-color': getFileSuffixMarkColor(row.fileName),
            }"
          >
            {{ splitFileSuffix(row.fileName) }}
          </div>
          <div class="doc__content-file__name">
            <div class="d-flex">
              <div v-if="row.isCustomer == 'Y'" class="doc__content-icon mr-2">
                <img :src="emailSecurityIcon" />
              </div>
              <p class="doc__content-file__name_wrapper">{{ row.fileName }}</p>
            </div>
            <div class="doc__content-file__desc">
              {{ row.remark }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
const emailSecurityIcon = require('../images/emailSecurity@3x.png')

export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      emailSecurityIcon,
      tableColumns: tableColumns(this),
      chooseSampleVisible: false,
      selectionCode: '',
      format: (n) => format(n),
            fileMarkColor: {
        'jpg,jpeg,png,gif,bmp,tiff,webp,svg': '#15A2B8',
        pdf: '#007bff',
        'ppt,pptx': '#E6A23C',
        'doc,docx': '#909399',
        'csv,xlsx,xlsm,xlsb,xltm': '#67C23A',
        zip: '#343a40',
        other: '#DCDFE6',
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = 420
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'binding':
          this.chooseSampleVisible = true
          this.selectionCode = data.selectionCode
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImage', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    splitFileSuffix(filename) {
      if (!filename) return ''
      const lastIndex = filename.lastIndexOf('.')
      if (lastIndex !== -1) return filename.slice(lastIndex)
      return ''
    },
    getFileSuffixMarkColor(filename) {
      const otherColor = this.fileMarkColor.other
      if (!filename) return otherColor
      const suffix = filename.split('.').pop()

      const types = Object.keys(this.fileMarkColor)

      const typeKey =
        types.filter(
          (type) => type.includes(suffix) || type.toUpperCase().includes(suffix)
        )[0] || ''
      return (
        this.fileMarkColor[typeKey] || this.fileMarkColor[typeKey.toUpperCase()]
      )
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
}
.doc__content-main {
  display: flex;
  .doc__content-file__suffix {
    width: 65px;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin-right: 6px;
  }
  .doc__content-file__name {
    width: calc(100% - 65px - 6px);
    p {
      margin-bottom: 0;
    }
    .doc__content-file__name_wrapper {
      width: 100%;
      line-height: 23px;
      color: #101010;
      display: inline-block;
      font-size: 14px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .doc__content-file__desc {
      color: #8e8e8e;
      font-size: 12px;
    }
  }
}
.icon_content {
  flex: 1;
  justify-content: end;
}
.doc__content-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  > img {
    width: 20px;
    height: 20px;
  }
}
</style>
